import { AnimatePresence } from "framer-motion";
import React from "react";
import { useSelector } from "react-redux";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import Navbar from "../Components/Navbar";
import Design from "../Pages/Design/Design";
import Home from "../Pages/Home/Home";
import NotFound from "../Pages/404/NotFound";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Form from "../Components/Modals/Form/Form";
import LogoutModal from "../Components/Modals/Logout";
import { RequireAuth } from "./PrivateRoute";
import Viewer from "../Pages/Viewer/Viewer";
import MyDuonut from "../Pages/MyDuonut/MyDuonut";
import DuonutSettingsPage from "../Components/DuonutSettings/DuonutSettings";
import MainDesign from "../Pages/Design/MainDesign";
import Templates from "../Pages/Templates/Templates";
import TemplateDetailsPage from "../Pages/TemplateDetailsPage/TemplateDetailsPage";
import CreateFromScratch from "../Components/Modals/CreateFromScratch/CreateFromScratch";
import DuonutNameModal from "../Components/Modals/DuonutNameModal/DuonutNameModal";
import OnBoarding from "../Pages/OnBoarding/OnBoarding";

import Contact from "../Pages/ContactUs/Contact";
import Pricing from "../Pages/Pricing/Pricing";

import DemoForm from "../Components/Modals/DemoForm/DemoForm";
import Profile from "../Pages/Profile";
import Payment from "../Pages/Payment/Payment";
import DuonutReports from "../Pages/DuonutReport/DuonutReports";
import DuonutAnalytics from "../Pages/DuonutAnalytics/DuonutAnalytics";

import Channel from "../Pages/Channel/Channel";
import Nugget from "../Pages/Nugget/Nugget";
import ChannelViewer from "../Pages/ChannelViewer/ChannelViewer";
import NuggetViewer from "../Pages/ChannelViewer/NuggetViewer";

import Integrations from "../Components/Integrations/Integrations";
import SlackSuccess from "../Components/SlackIntegration/SlackSuccess";

import PrivacyPolicy from "../Pages/PrivacyPolicy/PrivacyPolicy";
import TermCondition from "../Pages/TermCondition/TermCondition";
import CookiePolicy from "../Pages/CookiePolicy/CookiePolicy";

import Typeform from "../Pages/Help/Typeform";
import Jotform from "../Pages/Help/Jotform";
import SlackPage from "../Pages/Integrations/SlackPage";
import SlackHelp from "../Pages/Help/SlackHelp";
import HubspotHelp from "../Pages/Help/HubspotHelp";
import ProMessage from "../Components/Modals/ProMessage/ProMessage";
import UserSetting from "../Components/Modals/UserSetting/UserSetting";
import DuonutPageMapping from "../Pages/DuonutPageMapping/DuonutPageMapping";
import Pdf from "../Pages/Pdf";
import FlowChart from "../Components/FlowChart/FlowChart";
import Workflow from "../Pages/Workflow/Workflow";
import Sites from "../Pages/Sites/Sites";
import LoginPage from "../Pages/LoginPage/LoginPage";

import Schedules from "../Components/Schedules/Schedules";
import HubSpotSuccess from "../Components/HubSpotIntegration/HubSpotSuccess";
import HubspotPage from "../Pages/Integrations/HubspotPage";

import AiPage from "../Pages/AiPage/AiPage";
import ForgotPassword from "../Components/Modals/Form/forgotPassword";
import ChangePasswordModal from "../Components/Modals/Form/changePasswordModal";
import UserMapping from "../Components/Modals/UserMapping/UserMapping";


import AiStartPageNew from "../Pages/AiStartPageNew/AiStartPageNew";
import AiDataNew from "../Pages/AiDataNew/AiDataNew";
import AiDuonutPageNew from "../Pages/AiDuonutPageNew/AiDuonutPageNew";
import EmbedAiDuonutPageNew from "../Pages/AiDuonutPageNew/EmbedAiDuonutPageNew";
import Panel from "../Pages/PanelData/Panel";
import Credit from "../Pages/Credit/Credit";
import TemplatesModal from "../Components/Modals/TemplateModal/TemplatesModal";
import New from "../Pages/New/new";


import ConfirmDeleteUser from "../Components/Modals/ConfirmDeleteUser/ConfirmDeleteUser";
import CallbackPage from "../Pages/canva/CallbackPage";
// import TemplateModal from "../components/Modals/TemplateModal/TemplateModal";


//will contain all the navigation logic
const AppRoutes = () => {
  const { forgotPasswordActive, changePasswordModalActive } = useSelector((state) => state.formDetails);
  // const { videoModalActive } = useSelector((state) => state.activityCategories);
  // const { modalOpen: previewModalOpen } = useSelector((state) => state.preview);
  // const { modalOpen: settingsModalOpen } = useSelector((state) => state.duonutSettings);
  // const { preferenceActive } = useSelector((state) => state.userActivity);
  const { isLoggedIn, isOnboarded } = useSelector((state) => state.user);
  // const { active: confirmReplaceModalActive } = useSelector((state) => state.sidebarSliders.confirmReplaceModal);
  const userSettingModalActive = useSelector((state) => state.userSetting.modalActive);
  const userMappingModalActive = useSelector((state) => state.userMapping.modalActive);
  const { templateModal } = useSelector((state) => state.createFromScratch);

  return (
    <AnimatePresence>
      <BrowserRouter>
        <ToastContainer position="top-center" autoClose={3000} hideProgressBar={false} />
        <>
          {forgotPasswordActive && <ForgotPassword />}
          {changePasswordModalActive && <ChangePasswordModal />}
          {/* {previewModalOpen && <Preview />}
          {videoModalActive && <VideoUpload />}
          {settingsModalOpen && <DuonutSettings />}
          {preferenceActive && <PreferenceModal />}
          <ConfirmReplace />
          <ConfirmReplaceDuonut />*/}
          {userSettingModalActive && <UserSetting />}
          {userMappingModalActive && <UserMapping />}
          <DemoForm />
          <DuonutNameModal />
          <CreateFromScratch />
          <Form />
          <LogoutModal />
          <ProMessage />
          {templateModal && <TemplatesModal />}
          {/* <ActivityCategoriesModal />
          <DiscardOrSaveChanges />
          <FromUrl />
          <Feedback />
          <TemplateModal /> */}
          <ConfirmDeleteUser />

          <Navbar />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<LoginPage />} />
            {/* <Route path="/usergrowth" element={<Home />} /> */}
            {/* <Route path="/pdf" element={<Pdf />} /> */}

            <Route path="/canva/callback" element={<CallbackPage />} />

            <Route path="/pdf/:id" element={<Pdf />} />

            <Route path="/design" element={<Design editing={false} />} />
            {/* <Route path="/design/:id" element={<Design editing={true} />} /> */}
            <Route
              path="/design/:id"
              element={
                <RequireAuth isLoggedIn={isLoggedIn} isOnboarded={isOnboarded}>
                  <MainDesign editing={true} />
                </RequireAuth>
              }
            >
              <Route
                index
                element={
                  <RequireAuth isLoggedIn={isLoggedIn} isOnboarded={isOnboarded}>
                    <Design editing={true} />
                  </RequireAuth>
                }
              />
              <Route
                path="settings"
                element={<DuonutSettingsPage />}
              />
              <Route
                path="flow"
                element={<FlowChart />}
              />
              <Route
                path="integrations"
                element={<Integrations />}
              />
              <Route
                path="Schedules"
                element={<Schedules />}
              />
              <Route
                path="reports"
                element={<DuonutReports />}
              />
              <Route
                path="analytics"
                element={<DuonutAnalytics />}
              />

            </Route>

            <Route path="/duonut/:id" element={<Viewer />} />

            <Route path="/templates/:id" element={<Templates />} />
            <Route path="/templates/:id/:anotherId" element={<TemplateDetailsPage />} />

            <Route path="/termsandconditions" element={<TermCondition />} />
            <Route path="/privacypolicy" element={<PrivacyPolicy />} />
            <Route path="/cookiepolicy" element={<CookiePolicy />} />
            <Route path="/contactus" element={<Contact />} />
            <Route path="/pricing" element={<Pricing />} />

            <Route
              path="/profile"
              element={
                <RequireAuth isLoggedIn={isLoggedIn} isOnboarded={isOnboarded}>
                  <Profile />
                </RequireAuth>
              }
            />
            <Route
              path="/payment/:id"
              element={
                <RequireAuth isLoggedIn={isLoggedIn} isOnboarded={isOnboarded}>
                  <Payment />
                </RequireAuth>
              }
            />

            <Route
              path="/duonutreports/:id"
              element={
                <RequireAuth isLoggedIn={isLoggedIn} isOnboarded={isOnboarded}>
                  <DuonutReports />
                </RequireAuth>
              }
            />

            <Route
              path="/duonutanalytics/:id"
              element={
                <RequireAuth isLoggedIn={isLoggedIn} isOnboarded={isOnboarded}>
                  <DuonutAnalytics />
                </RequireAuth>
              }
            />

            <Route
              path="/workflow/:id"
              element={
                <RequireAuth isLoggedIn={isLoggedIn} isOnboarded={isOnboarded}>
                  <Channel />
                </RequireAuth>
              }
            />
            <Route
              path="/workflows/:id"
              element={
                <RequireAuth isLoggedIn={isLoggedIn} isOnboarded={isOnboarded}>
                  <Nugget />
                </RequireAuth>
              }
            />
            <Route path="/viewworkflow/:id" element={<ChannelViewer />} />
            <Route path="/viewworkflows/:id" element={<NuggetViewer />} />

            <Route
              path="/createworkflow"
              element={
                <RequireAuth isLoggedIn={isLoggedIn} isOnboarded={isOnboarded}>
                  <Workflow />
                </RequireAuth>
              }
            />
            <Route
              path="/workflow"
              element={
                <RequireAuth isLoggedIn={isLoggedIn} isOnboarded={isOnboarded}>
                  <Sites />
                </RequireAuth>
              }
            />

            <Route path="/ai" element={<AiPage />} />


            {/* <Route path="/home" element={<AiStartPage />} />
            <Route
              path="/aidata"
              element={
                <RequireAuth isLoggedIn={isLoggedIn} isOnboarded={isOnboarded}>
                  <AiData />
                </RequireAuth>
              }
            />
            <Route path="/survey/:id" element={<AiDuonutPage />} />
            <Route path="/survey/embed/:id" element={<EmbedAiDuonutPage />} /> */}
            <Route path="/home" element={<New />} />
            {/* <Route path="/home" element={<AiStartPageNew />} /> */}
            <Route path="/duonutai" element={<AiStartPageNew />} />
            <Route
              path="/aidata"
              element={
                <RequireAuth isLoggedIn={isLoggedIn} isOnboarded={isOnboarded}>
                  <AiDataNew />
                </RequireAuth>
              }
            />
            <Route path="/survey/:id" element={<AiDuonutPageNew />} />
            <Route path="/survey/embed/:id" element={<EmbedAiDuonutPageNew />} />


            <Route path="/pagemapping/:id" element={<DuonutPageMapping />} />

            <Route path="/help/duonut-a-free-typeform-alternative" element={<Typeform />} />
            <Route path="/help/best-free-jotform-alternative" element={<Jotform />} />
            <Route path="/help/how-to-integrate-duonut-with-slack" element={<SlackHelp />} />
            <Route path="/help/how-to-integrate-duonut-with-hubspot" element={<HubspotHelp />} />

            <Route path="/integrations/slack" element={<SlackPage />} />
            <Route path="/integrations/hubspot" element={<HubspotPage />} />

            <Route path="/slacksuccess" element={
              <RequireAuth isLoggedIn={isLoggedIn} isOnboarded={isOnboarded}>
                <SlackSuccess />
              </RequireAuth>} />
            <Route path="/hubspotsuccess" element={
              <RequireAuth isLoggedIn={isLoggedIn} isOnboarded={isOnboarded}>
                <HubSpotSuccess />
              </RequireAuth>} />

            <Route
              path="/myprojects"
              element={
                <RequireAuth isLoggedIn={isLoggedIn} isOnboarded={isOnboarded}>
                  <MyDuonut isMyDuonuts={true} />
                </RequireAuth>
              }
            />
            <Route
              path="/credit"
              element={
                <RequireAuth isLoggedIn={isLoggedIn} isOnboarded={isOnboarded}>
                  <Credit />
                </RequireAuth>
              }
            />
            <Route
              path="/paneldata"
              element={
                <RequireAuth isLoggedIn={isLoggedIn} isOnboarded={isOnboarded}>
                  <Panel />
                </RequireAuth>
              }
            />
            <Route
              path="/onboarding"
              element={
                // <RequireAuth isLoggedIn={isLoggedIn} isOnboarded={true}>
                <OnBoarding />
                // </RequireAuth>
              }
            />

            <Route path="*" element={<NotFound />} />
          </Routes>
        </>
      </BrowserRouter>
    </AnimatePresence >
  );
};

export default AppRoutes;
